import { protectedResources } from "../config/authConfig";
import { User } from "../types/user";
import { Workspace } from "../types/workspace";
import { _fetch, getToken } from "./apiHelper";

export const createWorkspace = async (workspace : Workspace, organizationId : string) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(workspace),
  };

  return _fetch(protectedResources.api.workspace + "/create-workspace/" + organizationId, options);
};

export const inviteUser = async (user : User): Promise<User> => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "POST",
    headers: headers,
    cache: "no-cache" as RequestCache,
    body: JSON.stringify(user),
  };

  return _fetch(protectedResources.api.workspace + "/invite-user", options);
};
export const getWorkspaces = async (): Promise<Workspace[]> => {
    const accessToken = await getToken();
  
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
  
    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");
  
    const options = {
      method: "GET",
      headers: headers,
      cache: "no-cache" as RequestCache,
    };
  
    return _fetch(protectedResources.api.workspace, options);
  };

  export const getWorkspacesByOrgId = async (orgId : string) => {
    const accessToken = await getToken();
  
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;
  
    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");
  
    const options = {
      method: "GET",
      headers: headers,
      cache: "no-cache" as RequestCache,
    };
  
    return _fetch(protectedResources.api.workspace + `/${orgId}`, options);
  };